import React from 'react'
import Link, { navigateTo, withPrefix } from 'gatsby-link'

//  Components
import ThemeList from '../ThemeList/ThemeList.js'
import statesUrl, { ReactComponent as States } from '../../assets/svg/states.svg'

//  Styles
import styles from './HomeIntro.module.scss'

const HomeIntro = ({ data }) => (
  <div className={ styles.home__intro }>
    <div className={ styles.home__intro__title }>
      <div className={ styles.home__intro__title__content }>
        <h1 className={ styles.site__title }><strong>{data.site.siteMetadata.year}</strong><br />
        {data.site.siteMetadata.subtitle}</h1>
        <p>A state-by-state report measuring access to care, quality of care, health outcomes, and health disparities across the United States</p>
        <p className={ styles.authors }>by David C. Radley, Sara R. Collins, and Susan L. Hayes</p>
      </div>
      <States className={ styles.home__intro__map } />
    </div>
    <div className={ styles.home__intro__themes }>
      <div className={ styles.home__intro__themes__content }>
        <h3 className={ styles.home__intro__themes__title }>Browse by Highlight or State</h3>
        <ThemeList themes={ data.allThemesJson.edges} />
        <select onChange={(e) => navigateTo(e.target.value) } className={ styles.state__header__select }>
          <option>Select a State</option>
          { data.allStatesJson.edges.map((node) =>
          <option key={ node.node.id } value={ withPrefix(`/state/${node.node.url}`) }>{ node.node.title }</option>
          )}
        </select>
      </div>
    </div>
  </div>
)

export default HomeIntro


// WEBPACK FOOTER //
// ./src/components/HomeIntro/HomeIntro.js